var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-improve-panel"},[(_vm.isComingSoonLayoutVisible)?_c('AIImprovePanelComingSoonLayout'):_vm._e(),(!_vm.canEditPresentation)?_c('div',{staticClass:"overlay-disable-edit"}):_vm._e(),_c('AIAutoImproveWriting',{staticClass:"ai-improve-panel__content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }